import {SearchModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class PositionSearchModel extends SearchModel<any> {

    constructor(injector: Injector) {
        super(injector);
    }

    override getIdentifierField(): string {
        return "positionId";
    }

    override isEntityLocalisable(): boolean {
        return false;
    }
}
